<template>
  <div class="organization-selector-container">
    <div class="container">
      <div class="row">
        <div v-if="organizations && organizations.data.length > 1" class="col-sm-12">
            <div class="form-group">
              <img :src="`${publicPath}covidLogo.png`" class="mx-auto d-block mt-5" alt="COVID Learners Logo" />
            </div>
            <div class="form-group h-100 align-items-center">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li v-for="member in members.data" :key="member.id" class="list-group-item" @click="selectMembership(member)">
                    <span>{{ getOrganizationName(getOrganizationFromMember(member)) }}</span>
                  </li>
                </ul>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
import { parseToken } from '@/services/jwt.service';
import { mapMutations, mapState } from 'vuex';
import { queryApi } from '@/services/api.service';
import OrganizationService from '@/services/organization.service';

export default {
  name: 'OrganizationSelector',
  mixins: [common],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      token: parseToken(),
      members: null,
      organizations: null,
      debugLog: false,
      userId: null,
    };
  },
  created() {
    this.userId = this.token.sub;
    this.log('OrganizationSelector -> Created', 'hit 1');
    Promise.all([
      this.getCurrentUser(),
      // TODO fix this to work with TTD-2196
      this.getOrganizationMemberships(),
    ]).then((responses) => {
      this.setCurrentUser(responses[0].data);
      this.members = responses[1].data;
      return this.getOrganizations();
    }).then(({ data }) => {
      this.organizations = data;
      if (this.members.data.length === 1) {
        this.setCurrentMember(this.members.data[0]);
        this.setDefaultOrganization({ data: this.organizations.data[0] });
        this.selectMembership(this.currentMember);
      }
    });
  },
  computed: {
    ...mapState(['currentUser', 'currentMember', 'defaultOrganization']),
  },
  methods: {
    ...mapMutations(['setCurrentUser', 'setDefaultOrganization', 'setCurrentMember']),
    getCurrentUser() {
      return queryApi(`users/${this.userId}`);
    },
    getOrganizationMemberships() {
      const memberParams = {
        'query[memberable_type_eq]': 'V2::Organization',
        'query[userable_id_eq]': this.token.sub,
        'query[userable_type_eq]': 'User',
        'query[sorts]': 'default DESC',
        'query[archived_eq]': '0',
        per_page: this.perPage,
      };
      return queryApi('members', memberParams);
    },
    getOrganizations() {
      const organizationIds = this.members.data.map((x) => x.relationships.memberable.data.id);

      const organizationParams = {
        'query[id_in]': organizationIds,
        'query[sorts]': 'created_at ASC',
        per_page: this.perPage,
      };
      return queryApi('organizations', organizationParams);
    },
    getOrganizationFromMember(member) {
      return this.organizations.data.find(
        (data) => data.id === member.relationships.memberable.data.id,
      );
    },
    selectMembership(member) {
      const organization = this.getOrganizationFromMember(member);
      this.log('OrganizationSelector -> SelectMembership -> OrganizationService.show', 'cached org', organization);
      const organizationId = organization.id;
      if (organizationId) {
        const secondsSinceEpoch = Math.round(Date.now() / 1000);
        const params = { timestamp: secondsSinceEpoch };
        OrganizationService.show(organizationId, params).then((response) => {
          localStorage.setItem('defaultOrganizationId', organizationId);
          this.log('OrganizationSelector -> SelectMembership -> OrganizationService.show', 'response', response);
          // kinda trash but we'll save vuex based on the result if members is length 1
          if (this.members.data.length > 1) {
            this.setDefaultOrganization({ data: response.data });
            this.setCurrentMember(member);
          }
          if (member.attributes.accepted_terms_of_service_at && member.attributes.accepted_privacy_policy_at) {
            this.safelyNavigateToPath('Home');
          } else {
            this.safelyNavigateToPath('LegalAgreement');
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./styles.scss">

</style>
